import { apiClientWithMiddleware, captureUndefinedPortalError, getApiConfigs } from './utils';
const USER_ATTRIBUTES_URL = 'notification/preferences/v1/generic-user-settings';
export const getUserAttributes = () => {
  const {
    queryConfig,
    clientConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return Promise.resolve(null);
  }
  return apiClientWithMiddleware(clientConfig).get(USER_ATTRIBUTES_URL, Object.assign({}, queryConfig)).then(({
    faviconIndicator,
    playTeaseSound,
    soundId,
    userId
  }) => {
    return {
      faviconIndicator,
      playTeaseSound,
      soundId: soundId !== null && soundId !== void 0 ? soundId : 1,
      userId
    };
  }).catch(err => {
    throw err;
  });
};